import React, { useState, useContext, useEffect, Fragment, memo } from "react";
import { AppContext } from "./../../../components/AppProvider";

export const SelectArea = memo((props) => {
  const {
    hospitalList,
    setHpCode,
    setHospitalName,
  } = props;
  const { pageState } = useContext(AppContext);
  const [ textHsptList, setTextHsptList ] = useState([]);
  const [ cnntHsptList, setCnntHsptList ] = useState([]);

  const firstSelectBoxEvent = (e) => {
    $(e.target)
      .closest(".select-gray-enable")
      .find("a.btn-select")
      .removeClass("gray");
    $(e.target).closest(".select-custom-box").removeClass("on");
    $(e.target)
      .closest(".select-custom-box")
      .find("a.btn-select")
      .html($(e.target).html());

    if (pageState.share == 0) {
      setHpCode(e.target.name);
      setHospitalName(e.target.text);
    } else {
      $("#targetHsptCd").val(e.target.name);
    }
  };

  useEffect(() => {
    setTextHsptList([]);
    setCnntHsptList([]);

    if(hospitalList.length > 0) {
      hospitalList.filter((hsptList) => {
        if (hsptList.dataType == "U") {
          setTextHsptList((textHsptList) => [...textHsptList, hsptList]);
        } else {
          setCnntHsptList((cnntHsptList) => [...cnntHsptList, hsptList]);
        }
      }
      );
    }
  }, [hospitalList])

  return (
    <Fragment>
      <div className="select-custom-box select-gray-enable">
        <a className="btn-select">병원 전체</a>
        <input type="hidden" id="targetHsptCd" value="" />
        <ul style={{ maxHeight: "160px", overflow: "auto" }}>
          <li>
            <a onClick={(e)=>firstSelectBoxEvent(e)}>병원 전체</a>
          </li>

          {cnntHsptList != null &&
            cnntHsptList.length > 0 &&
            cnntHsptList.map((m, i) => (
              <SelectList
                hpCode={m.hsptCd}
                hpName={m.hsptNm}
                dataType={m.dataType}
                address2={m.address2}
                firstSelectBoxEvent={firstSelectBoxEvent}
                key={i}
              />
            ))}
          {textHsptList != null &&
            textHsptList.length > 0 &&
            textHsptList.map((m, i) =>
              i === 0 ? (
                <Fragment key={"textHsptList"+i}>
                  <li>
                    <div
                      style={{
                        borderTop: "1px dashed #999",
                        fontSize: "10px",
                        margin: "0 15px",
                      }}
                    >
                      진료추가한 병원
                    </div>
                  </li>
                  <SelectList
                    hpCode={m.hsptCd}
                    hpName={m.hsptNm}
                    dataType={m.dataType}
                    address2={m.address2}
                    firstSelectBoxEvent={firstSelectBoxEvent}
                    key={i}
                  />
                </Fragment>
              ) : (
                <SelectList
                  hpCode={m.hsptCd}
                  hpName={m.hsptNm}
                  dataType={m.dataType}
                  address2={m.address2}
                  firstSelectBoxEvent={firstSelectBoxEvent}
                  key={i}
                />
              )
            )}
        </ul>
      </div>
    </Fragment>
  );
});

export const SelectList = (props) => {
  const { hpCode, hpName, dataType, address2, firstSelectBoxEvent } = props;

  return (
    <li key={hpCode}>
      <a onClick={(e)=>firstSelectBoxEvent(e)} name={hpCode}>
        {dataType == "P" ? hpName + "(" + address2 + ")" : hpName}
      </a>
    </li>
  );
};
